export function PageHeader({ overline, title, description, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 sm:gap-4 mb-6 sm:mb-8" data-testid="page-header">
      <div className="min-w-0">
        {overline && <div className="overline mb-2">{overline}</div>}
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#101828] break-words">{title}</h1>
        {description && <p className="text-zinc-500 mt-2 max-w-2xl text-sm sm:text-base">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    in_behandeling: { label: "In behandeling", cls: "bg-amber-50 text-amber-700 border-amber-200" },
    goedgekeurd: { label: "Goedgekeurd", cls: "bg-blue-50 text-blue-700 border-blue-200" },
    geleverd: { label: "Geleverd", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
    geannuleerd: { label: "Geannuleerd", cls: "bg-zinc-100 text-zinc-600 border-zinc-200" },
  };
  const m = map[status] || { label: status, cls: "bg-zinc-100 text-zinc-700 border-zinc-200" };
  return (
    <span className={`inline-flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-wider px-2 py-1 border rounded ${m.cls}`} data-testid={`status-${status}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {m.label}
    </span>
  );
}

export function formatEUR(n) {
  return new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }).format(n || 0);
}

export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("nl-NL", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}
